export default "__VITE_ASSET__eo3h9jLe__"